<div class="p-6 max-w-[600px] mx-auto bg-white rounded-xl shadow-lg">
    <!-- Título del diálogo -->
    <h2 class="text-center text-xl font-semibold text-gray-800 mb-4">
        Terminos y Condiciones
    </h2>

    <div [innerHTML]="termsConditions" class="terms-content text-gray-600 overflow-y-auto mb-4
    max-h-[400px] sm:max-h-[430px] md:max-h-[450px] lg:max-h-[470px] xl:max-h-[430px] 2xl:max-h-[450px]">
        
    </div>
    

    <!-- Botón de cierre -->
    <div class="flex justify-end mt-6">
        <button mat-raised-button color="primary" class="px-6 py-2 rounded-full" (click)="close()">
            Aceptar
        </button>
    </div>
</div>